export default "__VITE_ASSET__SJhvMwOg__"